module.exports = __webpack_public_path__ + "static/media/data_2.f85d482d.mp4";